import { render, staticRenderFns } from "./FireBallIcon.vue?vue&type=template&id=0a27c305&scoped=true&"
import script from "./FireBallIcon.vue?vue&type=script&lang=ts&"
export * from "./FireBallIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a27c305",
  null
  
)

export default component.exports